import requestAction from '../../utils/requestAction'
import ComplaintMessage from '../../models/ComplaintMessage';

export const upsertComplaintMessage = (complaintMessage: (ComplaintMessage), handleResponse?: (messageId: number) => void) =>
  requestAction('COMPLAINT_MESSAGE_UPSERT')(
    `complaints/message${(complaintMessage as ComplaintMessage).id ? `/${(complaintMessage as ComplaintMessage).id}` : ''}`,
    (complaintMessage as ComplaintMessage).id ? 'PUT' : 'POST',
    complaintMessage,
    undefined,
    undefined,
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response.messageId) })
